import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const siteSelectStyles = {
    container: (base) => ({ ...base, flex: 1, minWidth: 0 }),
    control: (base) => ({
        ...base,
        minHeight: '34px',
        fontSize: '12px',
        borderColor: 'rgba(255,255,255,0.12)',
        backgroundColor: 'rgba(255,255,255,0.03)',
        borderRadius: '4px',
        boxShadow: 'none',
        flexWrap: 'nowrap',
        '&:hover': { borderColor: 'rgba(255,255,255,0.25)' }
    }),
    singleValue: (base) => ({ ...base, color: 'white', fontSize: '12px' }),
    placeholder: (base) => ({ ...base, color: 'rgba(255,255,255,0.5)', fontSize: '12px' }),
    input: (base) => ({ ...base, color: 'white', fontSize: '12px' }),
    menu: (base) => ({ ...base, zIndex: 9999, backgroundColor: '#1e163c', border: '1px solid rgba(255,255,255,0.12)', minWidth: '200px' }),
    option: (base, state) => ({
        ...base,
        fontSize: '12px',
        padding: '6px 10px',
        backgroundColor: state.isSelected ? '#CB2C84' : state.isFocused ? 'rgba(0,93,229,0.1)' : 'transparent',
        color: 'white',
        '&:active': { backgroundColor: 'rgba(0,93,229,0.2)' }
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base) => ({ ...base, padding: '4px', color: 'rgba(255,255,255,0.5)' }),
    clearIndicator: (base) => ({ ...base, padding: '4px', color: 'rgba(255,255,255,0.5)' }),
};

const DocumentFilters = ({ filterOptions, filters, onFilterChange, onClearFilters }) => {
    return (
        <div className="document-filters">
            <div className="document-filters__dropdown">
                <span className="document-filters__label">Category</span>
                <Select
                    value={filters.category}
                    onChange={(val) => onFilterChange('category', val)}
                    options={filterOptions.categories}
                    placeholder="All Categories"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="document-filters__dropdown">
                <span className="document-filters__label">Site</span>
                <Select
                    value={filters.site}
                    onChange={(val) => onFilterChange('site', val)}
                    options={filterOptions.sites}
                    placeholder="All Sites"
                    isClearable
                    isSearchable
                    styles={siteSelectStyles}
                />
            </div>
            <div className="document-filters__search">
                <span className="document-filters__label">Search</span>
                <input
                    type="text"
                    className="document-filters__search-input"
                    placeholder="Search title, category, site..."
                    value={filters.search}
                    onChange={(e) => onFilterChange('search', e.target.value)}
                />
            </div>
            <button className="document-filters__clear-btn" onClick={onClearFilters}>
                Clear Filters
            </button>
        </div>
    );
};

DocumentFilters.propTypes = {
    filterOptions: PropTypes.shape({
        categories: PropTypes.array.isRequired,
        sites: PropTypes.array.isRequired,
    }).isRequired,
    filters: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
};

export default DocumentFilters;
